import React from "react";
import { Phone, Mail } from "lucide-react";
import SubPageLayout from "../components/SubPageLayout";
import LeadForm from "../components/LeadForm";
import { PHONE_TEL, PHONE_DISPLAY, EMAIL, SERVICE_AREAS } from "../data";

export default function Contact() {
  return (
    <SubPageLayout testid="contact-page" eyebrow="Contact" title="Talk With Our Team."
      subtitle="Schedule a free in-home water test, ask a question, or request a quote. A member of our local team will reach out personally."
      metaDescription="Contact Honest Water LLC to schedule a free in-home water test in Northern Virginia.">
      <section className="section-pad bg-[#F4F1E9]">
        <div className="container-hw grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-4">
            <p className="text-sm text-[#344C59]">Reach us directly</p>
            <a href={`tel:${PHONE_TEL}`} data-testid="contact-page-phone" className="mt-6 flex items-center gap-4 font-heading text-3xl text-[#172B38] hover:text-[#344C59]">
              <Phone className="w-5 h-5" strokeWidth={1.5} /> {PHONE_DISPLAY}
            </a>
            <a href={`mailto:${EMAIL}`} data-testid="contact-page-email" className="mt-4 flex items-center gap-4 text-[1.05rem] text-[#172B38] break-all hover:text-[#344C59]">
              <Mail className="w-5 h-5 shrink-0" strokeWidth={1.5} /> {EMAIL}
            </a>
            <div className="hw-rule my-10" />
            <p className="text-sm text-[#344C59]">Service area</p>
            <p className="mt-3 text-[#3E474B] leading-relaxed">{SERVICE_AREAS.join(", ")} and surrounding Northern Virginia communities.</p>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 bg-white border border-[#D9D6CC] p-7 md:p-12">
            <LeadForm id="contact-form" source="Website Contact Page" />
          </div>
        </div>
      </section>
    </SubPageLayout>
  );
}
